module.exports = __webpack_public_path__ + "static/media/feature_ellipse_2.f0c65167.png";